import styles from './styles.module.scss';
import React, { ChangeEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PureSelect } from '@clover/web-lib-core/dist/components';
import { Filters, FiltersMap } from './filters';

interface ComponentProps {
  allowedFilters?: Filters[];
  label?: string;
  onChangeHandlerCallback: (filterKey: Filters) => void;
  selectedFilter?: Filters;
}

export const FilterDropDown: React.FC<ComponentProps> = ({
  allowedFilters = Object.keys(FiltersMap) as unknown as Filters[],
  label = `drop_down.sort_by`,
  onChangeHandlerCallback,
  selectedFilter,
}): JSX.Element => {
  const [t] = useTranslation();
  const selectedOption = selectedFilter || allowedFilters[0];
  const availableOptions = useMemo(
    () =>
      allowedFilters.map(filter => {
        const { label, value } = FiltersMap[filter];
        return {
          label: t(label),
          value,
        };
      }),
    [allowedFilters, t],
  );

  const onChangeHandler = (event: ChangeEvent<{ name?: string; value: unknown }>): void => {
    let value = event.target.value as Filters;
    onChangeHandlerCallback(value);
  };

  return (
    <div className={styles.sortBy}>
      <PureSelect
        label={t(label)}
        onChange={onChangeHandler}
        options={availableOptions}
        value={selectedOption}
        data-id={t('aria.menu_item_id')}
        id={t('aria.menu_item_id')}
        aria-describedby={t('aria.menu_items')}
        data-testid = 'PureSelect'
      />
    </div>
  );
};
